import React from 'react';
import { motion } from 'framer-motion';
import { Gift, ShoppingBag, AlertTriangle, ClipboardCheck } from 'lucide-react';
export function Bonuses() {
  const bonuses = [{
    num: '01',
    icon: <ShoppingBag className="w-7 h-7 text-brand-cyan" data-id="element-192" />,
    tag: 'GUÍA DE COMPRAS INTELIGENTE',
    title: 'La Despensa del Ejecutivo Bio-X',
    desc: 'Tu lista de compras inteligente — sabe exactamente qué comprar, de qué marca y dónde, en menos de 30 minutos.',
    bullets: ['Kit completo de suplementación (10+ marcas reales con precios)', 'Listas de compras por fase del protocolo (Detox → Mantenimiento)', 'Código rojo del supermercado: cómo leer etiquetas en 10 segundos', 'Menú de supervivencia para 7 tipos de restaurante', 'Kit de viaje Bio-X imprimible'],
    val: '$67',
    pages: '15-20 páginas',
    accent: 'from-brand-cyan/20 to-brand-cyan/5',
    border: 'border-brand-cyan/40'
  }, {
    num: '02',
    icon: <AlertTriangle className="w-7 h-7 text-brand-red" data-id="element-193" />,
    tag: '7 TARJETAS TÁCTICAS',
    title: 'Protocolos de Emergencia Bio-X',
    desc: '7 protocolos para cuando la vida real ataca tu rutina: jet lag, cena de negocios con alcohol, semana de 80h, fatiga mental antes de una decisión crítica.',
    bullets: ['Sueño de Guerra — Dormiste 4h y tienes una presentación', 'Jet Lag Destroyer — 6+ zonas horarias en 24h', 'Blindaje Social — Cena con alcohol obligatoria', 'Modo Trinchera — Semana de 80+ horas, deadline imposible', 'Reinicio Sin Culpa · Claridad Instantánea · Nómada de Negocios'],
    val: '$87',
    pages: '12-15 páginas',
    accent: 'from-brand-red/20 to-brand-red/5',
    border: 'border-brand-red/40'
  }, {
    num: '03',
    icon: <ClipboardCheck className="w-7 h-7 text-brand-gold" data-id="element-194" />,
    tag: 'AUDITORÍA EN 5 MINUTOS',
    title: 'El Scorecard Bio-X',
    desc: 'Mide tus indicadores personales de rendimiento biológico en 5 minutos. Compara Día 0 vs Día 30 vs Día 90.',
    bullets: ['30 preguntas en lenguaje cotidiano (sin jerga médica)', '6 dimensiones: Energía · Sueño · Estrés · Cognición · Composición · Inflamación', 'Puntaje 0-100 con perfil personalizado (4 niveles)', 'Identifica tus 3 áreas prioritarias a atacar', 'Re-evaluación Día 30/60/90 con gráfico radar comparativo'],
    val: '$57',
    pages: 'PDF interactivo',
    accent: 'from-brand-gold/20 to-brand-gold/5',
    border: 'border-brand-gold/40'
  }];
  return <section className="py-24 px-6 bg-brand-bg-alt relative overflow-hidden" data-id="element-195">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[1000px] h-[1000px] bg-brand-purple/5 rounded-full blur-[150px] pointer-events-none" data-id="element-196" />

      <div className="max-w-[1100px] mx-auto relative z-10" data-id="element-197">
        {/* Section Reveal */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-198">
          <div className="inline-block mb-6" data-id="element-199">
            <span className="inline-flex items-center gap-2 bg-gradient-to-r from-brand-gold to-[#FFA502] text-black font-black px-5 py-2 rounded-full text-sm tracking-wide animate-pulse-slow shadow-lg" data-id="element-200">
              <Gift className="w-4 h-4" data-id="element-201" /> ESPERA — HAY MÁS
            </span>
          </div>

          <h2 className="text-4xl md:text-5xl font-black text-white mb-4 leading-tight" data-id="element-202">
            +3 Bonos Exclusivos
            <br data-id="element-203" />
            <span className="text-brand-gold" data-id="element-204">Totalmente Gratis</span>
          </h2>
          <p className="text-xl text-brand-muted max-w-[700px] mx-auto" data-id="element-205">
            Porque el conocimiento sin acción no sirve. Estos 3 bonos convierten
            la teoría del ebook en herramientas tácticas que usarás cada día.
          </p>
        </motion.div>

        {/* Bonus Cards */}
        <div className="space-y-8" data-id="element-206">
          {bonuses.map((bonus, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: idx * 0.1
        }} className={`relative bg-brand-card rounded-[24px] border-2 ${bonus.border} overflow-hidden`} data-id="element-207">
              {/* Gradient Accent */}
              <div className={`absolute inset-0 bg-gradient-to-br ${bonus.accent} pointer-events-none opacity-50`} data-id="element-208" />

              {/* FREE Badge */}
              <div className="absolute top-6 right-6 z-10" data-id="element-209">
                <span className="inline-block bg-brand-gold text-black font-black px-3 py-1 rounded-full text-xs tracking-wider shadow-lg" data-id="element-210">
                  GRATIS
                </span>
              </div>

              <div className="relative z-10 p-8 md:p-10 flex flex-col md:flex-row gap-8" data-id="element-211">
                {/* Left: Number + Icon */}
                <div className="flex md:flex-col items-center md:items-start gap-4 md:gap-6 shrink-0" data-id="element-212">
                  <div className="font-display text-6xl md:text-7xl font-bold text-white/10 leading-none" data-id="element-213">
                    {bonus.num}
                  </div>
                  <div className="w-14 h-14 rounded-full bg-brand-card-hover border border-brand-border flex items-center justify-center shadow-lg" data-id="element-214">
                    {bonus.icon}
                  </div>
                </div>

                {/* Right: Content */}
                <div className="flex-1" data-id="element-215">
                  <div className="flex flex-wrap items-center gap-2 mb-3" data-id="element-216">
                    <span className="text-xs font-bold uppercase tracking-widest text-brand-muted" data-id="element-217">
                      BONO #{bonus.num} — {bonus.tag}
                    </span>
                    <span className="text-xs text-brand-muted bg-brand-bg px-2 py-0.5 rounded-full border border-brand-border" data-id="element-218">
                      {bonus.pages}
                    </span>
                  </div>

                  <h3 className="text-2xl md:text-3xl font-black text-white mb-3 leading-tight" data-id="element-219">
                    {bonus.title}
                  </h3>

                  <p className="text-brand-muted leading-relaxed mb-6 max-w-[700px]" data-id="element-220">
                    {bonus.desc}
                  </p>

                  <ul className="space-y-2 mb-6" data-id="element-221">
                    {bonus.bullets.map((b, i) => <li key={i} className="flex items-start gap-3 text-sm md:text-base text-white/90" data-id="element-222">
                        <span className="text-brand-cyan mt-1 shrink-0" data-id="element-223">→</span>
                        <span data-id="element-224">{b}</span>
                      </li>)}
                  </ul>

                  <div className="flex items-center gap-3 pt-4 border-t border-brand-border/50" data-id="element-225">
                    <span className="text-brand-muted line-through font-mono text-sm" data-id="element-226">
                      Valor: {bonus.val}
                    </span>
                    <span className="text-brand-gold font-black text-sm tracking-wider" data-id="element-227">
                      → HOY: $0
                    </span>
                  </div>
                </div>
              </div>
            </motion.div>)}
        </div>

        {/* Summary */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="mt-12 text-center" data-id="element-228">
          <div className="inline-block bg-brand-bg border border-brand-gold/30 rounded-2xl px-8 py-5" data-id="element-229">
            <p className="text-sm text-brand-muted mb-1" data-id="element-230">
              Valor combinado de los 3 bonos
            </p>
            <p className="font-display text-3xl md:text-4xl font-bold" data-id="element-231">
              <span className="line-through text-brand-muted/60 mr-3" data-id="element-232">
                $211
              </span>
              <span className="text-brand-gold drop-shadow-[0_0_15px_rgba(255,215,0,0.3)]" data-id="element-233">
                GRATIS hoy
              </span>
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}